import axios from 'axios';

import { assertClientSide } from '@dr.pogodin/react-utils';

import type {
  CreateResearchLibCategoryBodyT,
  CreateResearchLibCategoryResT,
} from 'server/controllers/researchLib/createCategory';

import {
  P_API_RESEARCH_LIB_CATEGORY,
  type ResearchLibCategoryT,
  getConfig,
} from 'utils';

type CreateResearchLibCategoryArgT = {
  name: string;
};

export async function createResearchLibCategory({
  name,
}: CreateResearchLibCategoryArgT): Promise<ResearchLibCategoryT> {
  assertClientSide();

  const config = await getConfig();

  const res = await axios.post<CreateResearchLibCategoryResT>(
    P_API_RESEARCH_LIB_CATEGORY,
    {
      _csrf: config.CSRF,
      name,
    } satisfies CreateResearchLibCategoryBodyT,
  );

  return res.data;
}
